import React, { FC } from "react";
import Checklist from "_components/Checklist";

export interface PasswordGuideProps {
  password: string;
}

export const PasswordGuide: FC<PasswordGuideProps> = ({ password }) => {
  return (
    <Checklist
      items={[
        {
          key: "uppercase letter",
          name: "at least one uppercase letter",
          value: password.search(/[A-Z]/g) > -1,
        },
        {
          key: "lowercase letter",
          name: "at least one lowercase letter",
          value: password.search(/[a-z]/g) > -1,
        },
        {
          key: "number",
          name: "at least one number",
          value: password.search(/\d/g) > -1,
        },
        {
          key: "special",
          name: "at least one special character (@,$,!,%,*,? or &)",
          value: password.search(/[@$!%*?&]/g) > -1,
        },
        {
          key: "length",
          name: "at least 8 characters",
          value: password.length >= 8,
        },
      ]}
    />
  );
};
